import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'inverterFilter' })
export class InverterFilterPipe implements PipeTransform {
    transform(list: any[] | null, name: string) {
        if (list && name) {
            return list.filter(item => item.inverter.name.toLowerCase().indexOf(name.toLowerCase()) > -1);
        }
        return list;
    }
}